import { inject } from '@angular/core';
import { Router, CanActivateChildFn } from '@angular/router';

import { AuthService } from '../services/auth.service';

export const publicPagesGuard: CanActivateChildFn = () =>
  !inject(AuthService).isAuthenticated || inject(Router).createUrlTree(['/orders']);
